import { render, staticRenderFns } from "./PhysiciansBar.vue?vue&type=template&id=3c3d7aa4&"
import script from "./PhysiciansBar.vue?vue&type=script&lang=js&"
export * from "./PhysiciansBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports